export default __webpack_public_path__ + "static/media/avatar.f4cd8458.png";